import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import InputMask from 'react-input-mask'
import MaterialInputable from './MaterialInputable'

const styles = theme => ({
	textField: {
		marginLeft: theme.spacing.unit,
		marginRight: theme.spacing.unit,
	},
})

class MaterialZipcode extends React.Component {
	constructor(props) {
		super(props)

		this.beforeMaskedValueChange = this.beforeMaskedValueChange.bind(this)
	}

	beforeMaskedValueChange(newState, oldState, userInput) {
		var { value } = newState
		var selection = newState.selection
		var cursorPosition = selection ? selection.start : null

		if (value.endsWith('-') || value.endsWith(' ')) {
			if (cursorPosition === value.length) {
				cursorPosition--
				selection = { start: cursorPosition, end: cursorPosition }
			}
			value = value.slice(0, -1)
		}

		return {
			value,
			selection
		}
	}

	render() {
		const { name, value, country, onChange, onBlur, onKeyDown, disabled, ...otherProps } = this.props

		return (
			<InputMask
				mask={country === 'CAN' ? 'a9a 9a9' : '99999-9999'}
				maskChar={null}
				id={name}
				value={value}
				onChange={onChange}
				onBlur={onBlur}
				onKeyDown={onKeyDown}
				disabled={disabled}
				beforeMaskedValueChange={this.beforeMaskedValueChange}
			>
				{() =>
					<MaterialInputable
						name={name}
						disabled={disabled}
						{...otherProps}
					/>
				}
			</InputMask>
		)
	}
}

MaterialZipcode.propTypes = {
	classes: PropTypes.object,
	country: PropTypes.string,
	name: PropTypes.string.isRequired,
	label: PropTypes.string,
	value: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]).isRequired,
	placeholder: PropTypes.string,
	InputProps: PropTypes.object,
	disabled: PropTypes.bool,
	required: PropTypes.bool,
	error: PropTypes.bool,
	errorMessage: PropTypes.string,
	onChange: PropTypes.func,
	onBlur: PropTypes.func,
	onKeyDown: PropTypes.func, 
	InputLabelProps: PropTypes.object
}

MaterialZipcode.defaultProps = {
	country: 'USA',
	value: '',
	label: '',
	placeholder: '',
	disabled: false,
	required: false,
	error: false,
	errorMessage: '',
}

export default withStyles(styles)(MaterialZipcode)


// WEBPACK FOOTER //
// ./src/components/MaterialZipcode.jsx